import { Card, CardBody } from '@heroui/react';
import React from 'react';
import { FiClock } from 'react-icons/fi';

export const SettingsPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-200px)] p-6">
      <Card className="max-w-lg w-full">
        <CardBody className="p-12 text-center">
          <div className="w-20 h-20 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-6 text-primary-600">
            <FiClock size={40} />
          </div>
          <h1 className="title-large mb-4">Coming Soon</h1>
          <p className="text-lg text-default-500 mb-2">
            Settings are not available in the admin panel at this time.
          </p>
          <p className="text-sm text-default-400">
            This feature will be available in a future update.
          </p>
        </CardBody>
      </Card>
    </div>
  );
};
